import { TSearchPromosResponse_1 } from '../repositories/newbuilding-promos/v2/search-promos';
import { TIsCompilation } from '../types/compilation';

export const mapIsCompilation = (promosResponse: TSearchPromosResponse_1): TIsCompilation => {
  const isCompilation = promosResponse.isCompilation;

  return isCompilation || false;
};
